module.exports = __webpack_public_path__ + "static/media/galerija_2019 (20).60414a66.jpg";